import Account from "@/helper/AccountHelper.js";
import ConfigManager from '@/config/ConfigManager.js';
import BzbsApi from '@/core/Http/BzbsApi.js';
import { CartItemModel } from '@/core/Cart/model/CartItemModel';
import CampaignModel from '@/core/Campaign/model/CampaignModel.js';
import { PaymentChannelModel } from '../model/PaymentModel'
import { map } from 'rxjs/operators';

/**
 * @method apiDeleteCartItem
 * @method apiGetCartItem
 * @method apiGetCartUpsale
 */
export default {

    /**
     * @param {string} rowKey RowKey form api agency_items (apiGetCartList)
     */
    apiDeleteCartItem: function(rowKey) {
        let token = Account.getToken();
        let params = {
            key: rowKey,
        };
        let url = ConfigManager.getApiModuleUrl() + '/cart/delete';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    apiDeleteCartItemAll: function() {
        let token = Account.getToken();

        let url = ConfigManager.getApiModuleUrl() + '/cart/clear_all';
        return BzbsApi.connectBzbsPost(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },

    /**
     * Add item(s) to cart.
     * @param {Object} cartParams /core/ShoppingCart/model/AddCartModel.js
     */
     apiAddToCart: (cartParams) => {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/adds';
        return BzbsApi.connectBzbsPost(url, token, cartParams).pipe(map((res) => {
            return res.data;
        }));
    },


    /**
     * Get cart's Item.
     */
    apiGetCartItem: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/cart_item';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            var arrCartItem = [];
            for (let i of res.data) {
                let objCartItem = new CartItemModel();
                objCartItem.setFromCartItemApi(i);
                arrCartItem.push(objCartItem);
            }
            return arrCartItem;
        }));
    },

    apiGetCartQuantityCount: function() {
        return this.apiGetCartItem().pipe(map((data) => {
            var total = 0;
            var list = data;
            if (list) {
                for (var items of list) {
                    total += items.quantity;
                }
            }
            return total;
        }));
    },

    apiGetCartUpsale: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/upsale';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            if (res.data.success)
            var arrCampaign = [];
            for (var i of res.data.data) {
                var objCampaign = new CampaignModel(i);
                arrCampaign.push(objCampaign);
            }

            return arrCampaign;
        }));
    },
    apiPostSaveCart: function(saveCartParams) {
        let token = Account.getToken();
        const param = {
            device_app_id: ConfigManager.getAppId(),
        };
        const params = {...param,...saveCartParams};

        let url = ConfigManager.getApiModuleUrl() + '/cart/save_cart';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },

    apiGetCartConfig: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/main/cart_config';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data.data;
        }));
    },
    apiPostPlaceOrder: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/placeorder';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiGetShippingPrice: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiDeliveryModuleUrl() + '/express/quote';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiPostBookDriver: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiDeliveryModuleUrl() + '/express/book';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiGetDriverStatus: function (params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiDeliveryModuleUrl() + '/express/book_status';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiPostCancelDriver: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiDeliveryModuleUrl() + '/express/book_cancel';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data;
        }));
    },
    apiPostApprovePayment: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/approve_payment';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data.data;
        }));
    },
    apiGetPromotion: function () {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/promotions';
        return BzbsApi.connectBzbsGet(url, token, null).pipe(map((res) => {
            return res.data;
        }));
    },
    apiGetPaymentChannel: function(){
        let token = Account.getToken()
        let url = ConfigManager.getApiModuleUrl() + "/cart/payment_channel"
        return BzbsApi.connectBzbsGet(url, token).pipe(map((res) => {
            let paymentChannelList = [];
            for (var i of res.data.data) {
                let payment_channel = new PaymentChannelModel(i);
                paymentChannelList.push(payment_channel);
            }
            return paymentChannelList;
        }));
    },
    apiPromptpayCancel: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/omise_promptpay_cancel';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data.data;
        }));
    },
    apiPromptpayStatus: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/omise_promptpay_status';
        return BzbsApi.connectBzbsGet(url, token, params).pipe(map((res) => {
            return res.data.data;
        }));
    },
    apiCheckoutSubscription: function(params) {
        let token = Account.getToken();
        let url = ConfigManager.getApiModuleUrl() + '/cart/checkout_subscription';
        return BzbsApi.connectBzbsPost(url, token, params).pipe(map((res) => {
            return res.data.data;
        }));
    },
}
